import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { IFiSnackbarData } from './snack-bar.service';
import { Component, OnInit, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'fi-snackbar',
    templateUrl: './fi-snackbar.component.html',
    styleUrls: ['./fi-snackbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-snackbar' },
    standalone: false,
})
export class FiSnackbarComponent implements OnInit {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: IFiSnackbarData,
        private snackbarRef: MatSnackBarRef<any>,
    ) {}

    ngOnInit() {}

    onButtonClick() {
        this.snackbarRef.dismissWithAction();
    }

    protected getButtonText(): string {
        return this.data.preventButtonUppercase ? this.data.buttonText : this.data.buttonText.toUpperCase();
    }
}
